import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations, languages } from '../translations';

// Create the context
const LanguageContext = createContext();

// Create a custom hook for using the language context
export const useLanguage = () => useContext(LanguageContext);

// Create the Language Provider component
export const LanguageProvider = ({ children }) => {
  // Initialize language from localStorage or default to 'english'
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'english';
  });

  // Get the translation object for the current language
  const translation = translations[currentLanguage] || translations.english;

  // Update localStorage when language changes
  useEffect(() => {
    localStorage.setItem('language', currentLanguage);
  }, [currentLanguage]);

  // Function to change the language
  const changeLanguage = (languageCode) => {
    if (translations[languageCode]) {
      setCurrentLanguage(languageCode);
    }
  };

  // Create the value object with all needed properties and functions
  const value = {
    currentLanguage,
    translation,
    languages,
    changeLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext; 